module.exports = __webpack_public_path__ + "img/block2-2.a29166e4.jpg";